import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { NextPageContext } from 'next';
import { apolloClient } from '@/api/apolloClient';
import { GetCategoryResponse } from '@/api/types/categories.types';
import { GET_CATEGORY } from '@/api/queries/categories.queries';
import { getCategoryPath } from '@/utils/helpers';

export async function getCurrentCategory(
  client: ApolloClient<NormalizedCacheObject>,
  context: NextPageContext
) {
  const categoryPath = getCategoryPath(context.asPath);

  const category = await apolloClient<GetCategoryResponse>(
    client,
    {
      query: GET_CATEGORY,
      variables: { path: categoryPath },
    },
    context
  );

  return category?.data?.category || null;
}
